__turbopack_context__.v({
  "className": "ibm_plex_sans_cdeeeeec-module__H9bzMa__className",
  "variable": "ibm_plex_sans_cdeeeeec-module__H9bzMa__variable",
});
